// src/routes/formRoutes.js
import React, { Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import ProtectedRoute from '../components/auth/ProtectedRoute';

// Loading fallback
const LoadingFallback = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <CircularProgress />
  </Box>
);

// Form builder pages
const FormBuilder = React.lazy(() => import('../pages/forms/FormBuilder'));
const Forms = React.lazy(() => import('../pages/forms/Forms'));
const FormDetail = React.lazy(() => import('../pages/forms/FormDetail'));
const FormSubmissions = React.lazy(() => import('../pages/forms/FormSubmissions'));
const FormSubmissionDetail = React.lazy(() => import('../pages/forms/FormSubmissionDetail'));

// Public form pages
const PublicFormView = React.lazy(() => import('../pages/forms/public/PublicFormView'));
const FormPasswordProtection = React.lazy(() => import('../components/forms/renderer/FormPasswordProtection'));
const ThankYouPage = React.lazy(() => import('../pages/forms/public/ThankYouPage'));

const formRoutes = [
  // Authenticated form routes
  <Route 
    path="forms" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'forms', action: 'read' }}>
        <Suspense fallback={<LoadingFallback />}><Forms /></Suspense>
      </ProtectedRoute>
    } 
  />,
  
  <Route 
    path="forms/create" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'forms', action: 'create' }}>
        <Suspense fallback={<LoadingFallback />}><FormBuilder /></Suspense>
      </ProtectedRoute>
    } 
  />,
  
  <Route 
    path="forms/:formId" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'forms', action: 'read' }}>
        <Suspense fallback={<LoadingFallback />}><FormDetail /></Suspense>
      </ProtectedRoute>
    } 
  />,
  
  <Route 
    path="forms/:formId/edit" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'forms', action: 'update' }}>
        <Suspense fallback={<LoadingFallback />}><FormBuilder /></Suspense>
      </ProtectedRoute>
    } 
  />,
  
  <Route 
    path="forms/:formId/share" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'forms', action: 'update' }}>
        <Suspense fallback={<LoadingFallback />}><FormBuilder /></Suspense>
      </ProtectedRoute>
    } 
  />,
  
  <Route 
    path="forms/:formId/submissions" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'forms', action: 'read' }}>
        <Suspense fallback={<LoadingFallback />}><FormSubmissions /></Suspense>
      </ProtectedRoute>
    } 
  />,
  
  <Route 
    path="forms/:formId/submissions/:submissionId" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'forms', action: 'read' }}>
        <Suspense fallback={<LoadingFallback />}><FormSubmissionDetail /></Suspense>
      </ProtectedRoute>
    } 
  />,
  
  // Public form routes are now defined directly in router/index.js
  
  // Redirect
  <Route path="forms/*" element={<Navigate to="/forms" replace />} />
];

export default formRoutes;